module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("First published in 2010 by"), _c('br'), _vm._v("Red Wheel/Weiser, LLC"), _c('br'), _vm._v("With offices at:"), _c('br'), _vm._v("500 Third Street, Suite 230"), _c('br'), _vm._v("San Francisco, CA 94107"), _c('br'), _c('em', [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.redwheelweiser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.redwheelweiser.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2010 by Addie Johnson."), _c('br'), _vm._v("All rights reserved. No part of this publication may be"), _c('br'), _vm._v("reproduced or transmitted in any form or by any means,"), _c('br'), _vm._v("electronic or mechanical, including photocopying, recording,"), _c('br'), _vm._v("or by any information storage and retrieval system, without"), _c('br'), _vm._v("permission in writing from Red Wheel/Weiser, LLC."), _c('br'), _vm._v("Reviewers may quote brief passages.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 978-1-57324-474-9"), _c('br'), _vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("is available upon request.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Cover and text design by Jessica Dacher"), _c('br'), _vm._v("Proofread by Erin Brenner"), _c('br'), _vm._v("Typeset in Trade Gothic, Triplex, and French Iconic")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in Hong Kong"), _c('br'), _vm._v("GW"), _c('br'), _vm._v("10  9  8  7  6  5  4  3  2  1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6744ad5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 69
// module chunks = 0